import { BRAND_REFRESH_BANNER_COUNTDOWN_DAYS } from './constants'

const MS_PER_DAY = 24 * 60 * 60 * 1000

export interface BrandRefreshBannerCountdown {
  daysRemaining: number
  isExpired: boolean
  startedAt: string | null
}

export function getCountdownFromStartedAt(
  startedAtIso: string | null | undefined,
  {
    nowMs = Date.now(),
    countdownDays = BRAND_REFRESH_BANNER_COUNTDOWN_DAYS,
    forceExpired = false,
  }: {
    nowMs?: number
    countdownDays?: number
    forceExpired?: boolean
  } = {},
): BrandRefreshBannerCountdown {
  if (forceExpired) {
    return { daysRemaining: 0, isExpired: true, startedAt: startedAtIso ?? null }
  }

  if (!startedAtIso) {
    return {
      daysRemaining: countdownDays,
      isExpired: false,
      startedAt: null,
    }
  }

  const startedMs = Date.parse(startedAtIso)
  if (Number.isNaN(startedMs)) {
    return {
      daysRemaining: countdownDays,
      isExpired: false,
      startedAt: null,
    }
  }

  const daysElapsed = Math.floor((nowMs - startedMs) / MS_PER_DAY)
  const daysRemaining = Math.max(0, countdownDays - daysElapsed)

  return {
    daysRemaining,
    isExpired: daysRemaining === 0,
    startedAt: startedAtIso,
  }
}
